import { useRef, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';

export default function AxlSearchInput({ placeholder = 'Search here...', searchAction = () => {/* empty */} }) {
  const searchInputRef = useRef(null);
  const [searchValue, setSearchValue] = useState('');

  const handleClear = () => {
    setSearchValue('');
    searchAction('');
    searchInputRef.current?.focus();
  };

  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  return (
    <Box py={2}>
      <form
        style={{ display: 'flex', width: '100%' }}
        onSubmit={(e) => {
          e.preventDefault();
          searchAction(searchValue);
        }}
      >
        <Box display={'flex'} gap={2} flex={1}>
          <TextField
            placeholder={placeholder}
            variant="outlined"
            size="small"
            fullWidth
            value={searchValue}
            onChange={handleChange}
            inputRef={searchInputRef}
            slotProps={{
              input: {
                sx: {
                  bgcolor: '#fff',
                },
                startAdornment: <SearchIcon fontSize="inherit" />,
                endAdornment: searchValue && (
                  <IconButton
                    onClick={handleClear}
                    size="small"
                  >
                    <ClearIcon fontSize="inherit" />
                  </IconButton>
                ),
              },
            }}
          />

          <Button type="submit" variant="contained" color="primary" size="small" disableElevation>
            Search
          </Button>
        </Box>
      </form>
    </Box>
  );
}
